import _ from 'lodash';
import CredentialsApi from '../../api/CredentialsApi';

const state = {
  loading: false,
  finishedAddingCards: false,
  finishedAddingBanks: false,
  cardSourcesToAdd: [],
  bankSourcesToAdd: [],
};

const getters = {};

const actions = {
  async createCreds({ commit }) {
    commit('setLoading', { loading: true });
    const sourceNames = _.map([...state.bankSourcesToAdd, ...state.cardSourcesToAdd], source => source.sourceName);
    await CredentialsApi.createMultipleCredentials({ sourceNames });
    commit('setLoading', { loading: false });
  },
  async setFinishedAddingCards({ commit }) {
    commit('setFinishedAddingCards');
  },
  async setFinishedAddingBanks({ commit }) {
    commit('setFinishedAddingBanks');
  },
  addSourceCard({ commit }, { source }) {
    commit('addSourceCard', { source });
  },
  removeSourceCard({ commit }, { index }) {
    commit('removeSourceCard', { index });
  },
  addSourceBank({ commit }, { source }) {
    commit('addSourceBank', { source });
  },
  removeSourceBank({ commit }, { index }) {
    commit('removeSourceBank', { index });
  },
};

// mutations
const mutations = {
  setFinishedAddingCards(state) {
    state.finishedAddingCards = true;
  },
  setFinishedAddingBanks(state) {
    state.finishedAddingBanks = true;
  },
  addSourceCard(state, { source }) {
    state.cardSourcesToAdd.push(source);
  },
  addSourceBank(state, { source }) {
    state.bankSourcesToAdd.push(source);
  },
  removeSourceCard(state, { index }) {
    state.cardSourcesToAdd.splice(index, 1);
  },
  removeSourceBank(state, { index }) {
    state.bankSourcesToAdd.splice(index, 1);
  },
  setLoading(state, { loading }) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
